(() => {
  class t extends HTMLElement {
    constructor() {
      return (
        super(),
        (this.step = 1),
        (this.result = this.querySelector(".quiz_result_weight strong")),
        (this.resultTitle = this.querySelector("[data-result-title]")),
        (this.topWrapper = this.querySelector(".quiz_top")),
        (this.topSteps = this.querySelector(".quiz_top_steps")),
        (this.stepEl = this.topSteps.querySelector("span")),
        (this.image = this.querySelector(".quiz_result_image")),
        (this.nextBtns = this.querySelectorAll(".next-container")),
        (this.inputText = this.querySelector("#quiz-name")),
        (this.totalSteps = this.querySelectorAll("[data-step]").length),
        (this.stepName = this.querySelector(
          "[data-name]:not([hidden])"
        ).dataset.name),
        (this.welcome = this.querySelector('[data-name="welcome"]')),
        (this.nameInput = this.querySelector(
          '.quiz_name-wrapper input[name="name"]'
        )),
        (this.emailInput = this.querySelector(
          '.quiz_name-wrapper input[name="email"]'
        )),
        (this.next = this.querySelector(".quiz_next")),
        (this.back = this.querySelector(".quiz_back")),
        (this.variantSelect = this.querySelector('input[type="radio"]')),
        (this.names = {}),
        (this.product = {}),
        (this.resultData = {}),
        this.addEventListener("change", this.handleInput.bind(this)),
        this.nextBtns.forEach(
          function (t) {
            t.addEventListener("click", this.nextStep.bind(this));
          }.bind(this)
        ),
        this.welcome.addEventListener("click", this.nextStep.bind(this)),
        this.nameInput.addEventListener(
          "keypress",
          function (t) {
            let e = t.target;
            e.nextElementSibling ||
              ("Enter" === t.key && this.nextStep(),
              e.closest("div").nextElementSibling.removeAttribute("disabled"));
          }.bind(this)
        ),
        this.emailInput.addEventListener(
          "keypress",
          function (t) {
            let e = t.target,
              i = theme.utils.EMAIL_REGEX.test(e.value);
            "Enter" === t.key &&
              i &&
              theme.utils.klaviyo(e.value, { quizSubscribe: !0 });
            let s = e.closest("div").nextElementSibling;
            i ? s.removeAttribute("disabled") : s.setAttribute("disabled", "");
          }.bind(this)
        ),
        this.next.addEventListener("click", this.nextQuestion.bind(this)),
        document.addEventListener("keyup", function (t) {
          if (
            13 === t.keyCode &&
            "false" !=
              document.querySelector('.quiz_question[data-step="1"]').dataset
                .completed
          ) {
            let t = document.querySelector(".quiz_next");
            "none" != getComputedStyle(t).display &&
              document.querySelector(".quiz_next").click();
          }
        }),
        this.back.addEventListener("click", this.backQuestion.bind(this)),
        location.search.includes("continue=true")
          ? this.updateStep()
          : location.search.includes("step") && this.updateURL(),
        this
      );
    }
    handleInput(t) {
      let e = t.target.name,
        i = t.target.value;
      if (((theme.quiz.data[e] = i), "email" !== e))
        if ("name" !== e)
          "weight" === e
            ? (this.names.weight = parseInt(i))
            : (this.names[e] = i),
            (this.querySelector(
              '[data-step="' + this.step + '"]'
            ).dataset.completed = "true");
        else {
          this.inputText.innerHTML = i;
          let e = t.target.closest("div").nextElementSibling;
          t.target.nextElementSibling || e.removeAttribute("disabled");
        }
      else {
        if (1 !== this.step) return;
        let e = theme.utils.EMAIL_REGEX.test(i),
          s = t.target.closest("div").nextElementSibling;
        e
          ? (s.removeAttribute("disabled"),
            theme.utils.klaviyo(theme.quiz.data.email, { quizSubscribe: !0 }))
          : s.setAttribute("disabled", "");
      }
    }
    nextStep() {
      let t = this.querySelector(".quiz_content:not([hidden])"),
        e = t.nextElementSibling;
      t.setAttribute("hidden", ""),
        e.removeAttribute("hidden"),
        t.nextElementSibling.hasAttribute("data-step") &&
          this.topWrapper.removeAttribute("hidden"),
        this.updateURL(),
        setTimeout(function () {
          e.classList.add("quiz-transition");
        }, 100);
    }
    nextQuestion(t) {
      if (
        1 == this.step ||
        2 == this.step ||
        3 == this.step ||
        4 == this.step
      ) {
        this.querySelector('[data-step="' + this.step + '"]').setAttribute(
          "hidden",
          ""
        ),
          (this.step = this.step + 1),
          this.step < this.totalSteps
            ? (this.stepEl.innerHTML = "0" + this.step)
            : (this.getResults(), this.topWrapper.setAttribute("hidden", "")),
          this.querySelector('[data-step="' + this.step + '"]') &&
            this.querySelector(
              '[data-step="' + this.step + '"]'
            ).removeAttribute("hidden");
        let t = this.querySelector('[data-step="' + this.step + '"]');
        this.updateURL(),
          setTimeout(function () {
            t.classList.add("quiz-transition");
          }, 100),
          theme.utils.klaviyo(theme.quiz.data.email, {
            quizData: theme.quiz.data,
          });
      }
    }
    backQuestion() {
      if (1 === this.step) return;
      this.querySelector('[data-step="' + this.step + '"]').setAttribute(
        "hidden",
        ""
      ),
        (this.step = this.step - 1),
        (this.stepEl.innerHTML = "0" + this.step),
        this.querySelector('[data-step="' + this.step + '"]').removeAttribute(
          "hidden"
        );
      let t = this.querySelector('[data-step="' + this.step + '"]');
      this.updateURL(),
        setTimeout(function () {
          t.classList.add("quiz-transition");
        }, 100);
    }
    getUrl() {
      let t,
        e = this.querySelector(
          '.quiz_result_link[data-product="' + this.product.keyword + '"]'
        ),
        i = this.names.weight,
        s = this.product.url,
        a = this.product.variants.find(function (e) {
          if (e.weight === i) return t || (t = e), e.available;
        });
      a || (a = t),
        a?.id && (s = "".concat(this.product.url, "?variant=").concat(a.id)),
        (e.href = s),
        (this.resultData.url = s);
    }
    getResults() {
      let t;
      "Hot" == this.names.temperature
        ? ((t = "Tree Napper"),
          10 === this.names.weight && (this.names.weight = 15))
        : "Average" == this.names.temperature
        ? (t = "Cotton Weighted Blanket")
        : "Cold" == this.names.temperature &&
          ((t = "Cotton Weighted Blanket"),
          10 === this.names.weight && (this.names.weight = 15)),
        "Yes" == this.names.cover && "Queen" == this.names.size
          ? ((t = "Queen Weighted Blanket"),
            10 === this.names.weight || 15 === this.names.weight
              ? (this.names.weight = 20)
              : (this.names.weight = 30))
          : "Yes" == this.names.cover &&
            "King" == this.names.size &&
            ((t = "King Weighted Blanket"), (this.names.weight = 25)),
        "name" in theme.quiz.data &&
          (this.resultTitle.innerHTML = "Hey "
            .concat(theme.quiz.data.name, ",<br>")
            .concat(this.resultTitle.innerHTML)),
        (this.product = theme.quiz[t]);
      let e = this.names.weight + " lbs " + t;
      (this.result.innerHTML = e),
        this.getUrl(),
        (this.image.src = this.product.image),
        (this.resultData.image = this.product.small_image),
        document.body.classList.add("result-" + this.product.keyword),
        this.querySelector(
          '.quiz_result_link[data-product="' + this.product.keyword + '"]'
        ).removeAttribute("hidden"),
        (theme.quiz.data.result = e),
        (this.resultData.title = e),
        sessionStorage.setItem(
          "BearabyQuizResult",
          JSON.stringify(this.resultData)
        ),
        theme.utils.klaviyo("quizCompleted", theme.quiz.data, "track");
    }
    updateURL() {
      if (
        null != this.querySelector("[data-name]:not([hidden])").dataset.name
      ) {
        this.stepName = this.querySelector(
          "[data-name]:not([hidden])"
        ).dataset.name;
        let t = new URLSearchParams(window.location.search);
        t.set("step", this.stepName);
        let e = window.location.pathname + "?" + t.toString();
        history.pushState(null, "", e),
          "welcome" === this.stepName &&
            setTimeout(
              function () {
                "welcome" === this.stepName && this.nextStep();
              }.bind(this),
              3e3
            );
      }
    }
    updateStep() {
      let t = [],
        e = window.location.search.slice(1).split("&");
      this.querySelector('[data-name="start"]').setAttribute("hidden", ""),
        e.forEach(function (e) {
          let i = e.split("=")[0],
            s = decodeURIComponent(e.split("=")[1]);
          if ("q_" === i.slice(0, 2)) {
            let t = i.slice(2);
            theme.quiz.data[t] = s;
            let e = this.querySelector('.quiz_question[data-name="' + t + '"]');
            if (e) {
              (e.dataset.completed = "true"),
                e.classList.add("quiz-transition");
              let t = e.querySelector('input[value="' + s + '"]');
              t && (t.checked = !0);
            }
          } else "continue" !== i && "" !== s && t.push(e);
        });
      let i = t.length > 0 ? "?" + t.join("&") : "",
        s = window.location.pathname + i;
      history.pushState(null, "", s);
      let a = this.querySelector('.quiz_question[data-completed="false"]');
      a && "step" in a.dataset
        ? (this.topWrapper.removeAttribute("hidden"),
          (this.step = parseInt(a.dataset.step)),
          (this.stepEl.innerHTML = "0" + this.step),
          a.removeAttribute("hidden"),
          setTimeout(function () {
            a.classList.add("quiz-transition");
          }, 100))
        : this.querySelector('[data-name="start"]').removeAttribute("hidden");
    }
  }
  customElements.define("quiz-component", t);
})();
